import emailjs from '@emailjs/browser';

export const sendEmail = async ({ templateID, params }) => {
    const sender = emailjs.send('service_4bgbjbr', templateID, params, 'JT4nOX3hk25XdKeYk');
    return sender;
}